export default __webpack_public_path__ + "static/media/ks.cae31bb0.svg";